"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startEventCollection = startEventCollection;
const rawRumEvent_types_1 = require("../../rawRumEvent.types");
const allowedEventTypes = [
    rawRumEvent_types_1.RumEventType.ACTION,
    rawRumEvent_types_1.RumEventType.ERROR,
    rawRumEvent_types_1.RumEventType.LONG_TASK,
    rawRumEvent_types_1.RumEventType.RESOURCE,
    rawRumEvent_types_1.RumEventType.VITAL,
];
function startEventCollection(lifeCycle) {
    return {
        addEvent: (startTime, event, domainContext, duration) => {
            if (!allowedEventTypes.includes(event.type)) {
                return;
            }
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
                startTime,
                rawRumEvent: event,
                domainContext,
                duration,
            });
        },
    };
}
//# sourceMappingURL=eventCollection.js.map